// src/components/guest/layout/Header.jsx
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone, FaEnvelope, FaSignInAlt } from 'react-icons/fa';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '#home' },
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' },
  ];

  const handleNavClick = (href) => {
    setIsMenuOpen(false);
    if (href.startsWith('#')) {
      if (location.pathname !== '/') {
        window.location.href = '/' + href;
      } else {
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="shadow-lg sticky top-0 z-50 bg-primary-600">
      {/* Top contact bar */}
      <div className="bg-white text-primary-900 py-2 px-4">
        <div className="container mx-auto flex items-center justify-between text-sm">
          <div className="flex items-center gap-4">
            <a
              href="tel:6037462403"
              className="flex items-center gap-1.5 hover:text-primary-200 transition-colors"
            >
              <FaPhone className="w-3 h-3 flex-shrink-0" />
              <span>(603) 746-2403</span>
            </a>
            <a
              href="mailto:info@winnepocketlandscaping.com"
              className="hidden sm:flex items-center gap-1.5 hover:text-primary-200 transition-colors"
            >
              <FaEnvelope className="w-3 h-3 flex-shrink-0" />
              <span>info@winnepocketlandscaping.com</span>
            </a>
          </div>
          <span className="hidden md:block text-primary-900 text-xs">
            Landscaping for Central New Hampshire
          </span>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img
              src="/winnepocketbanner.webp"
              alt="Winnepocket Landscaping"
              className="h-10 sm:h-12 w-auto object-contain"
            />
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6">
            {navigation.map((item) =>
              item.href.startsWith('#') ? (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item.href)}
                  className="text-white hover:text-primary-200 font-medium transition-colors text-sm"
                >
                  {item.name}
                </button>
              ) : (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-white hover:text-primary-200 font-medium transition-colors text-sm"
                >
                  {item.name}
                </Link>
              )
            )}
            <Link
              to="/login"
              className="flex items-center gap-2 px-4 py-2 bg-white text-primary-700 text-sm font-medium rounded-lg hover:bg-primary-100 transition-colors shadow-sm"
            >
              <FaSignInAlt className="w-3.5 h-3.5" />
              Login
            </Link>
          </div>

          {/* Mobile: login + hamburger */}
          <div className="md:hidden flex items-center gap-3">
            <Link
              to="/login"
              className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-primary-700 text-sm font-medium rounded-lg hover:bg-primary-100 transition-colors"
            >
              <FaSignInAlt className="w-3.5 h-3.5" />
              Login
            </Link>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-white hover:text-primary-200 transition-colors rounded-lg hover:bg-primary-600"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <FaTimes className="w-5 h-5" />
              ) : (
                <FaBars className="w-5 h-5" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile dropdown menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-100 py-3 pb-4">
            <div className="flex flex-col gap-1">
              {navigation.map((item) =>
                item.href.startsWith('#') ? (
                  <button
                    key={item.name}
                    onClick={() => handleNavClick(item.href)}
                    className="text-left text-white hover:text-primary-600 hover:bg-gray-50 font-medium px-2 py-2.5 rounded-lg transition-colors text-sm"
                  >
                    {item.name}
                  </button>
                ) : (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsMenuOpen(false)}
                    className="text-white hover:text-primary-600 hover:bg-gray-50 font-medium px-2 py-2.5 rounded-lg transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                )
              )}
              {/* Email in mobile menu since it's hidden in top bar */}
              <a
                href="mailto:info@winnepocketlandscaping.com"
                className="flex items-center gap-2 text-white hover:text-primary-600 hover:bg-gray-50 px-2 py-2.5 rounded-lg transition-colors text-sm mt-1 border-t pt-3"
              >
                <FaEnvelope className="w-3.5 h-3.5 flex-shrink-0" />
                info@winnepocketlandscaping.com
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;